import { Action } from 'common/interfaces/root';
import { gainzRevenueActionTypes as TYPES } from '../actions/action-types';

const initialState: AffiliateGainzModule.GainzRevenueModule.RevenueModule.RevenueState = {
  loading: false,
  data: null,
  error: null,
};

export default (
  state: AffiliateGainzModule.GainzRevenueModule.RevenueModule.RevenueState = initialState,
  { type, payload }: Action
): AffiliateGainzModule.GainzRevenueModule.RevenueModule.RevenueState => {
  switch (type) {
    case TYPES.REVENUE.GET_REVENUE:
      return { ...state, loading: true };
    case TYPES.REVENUE.GET_REVENUE_SUCCESS:
      return { ...state, loading: false, data: payload };
    case TYPES.REVENUE.GET_REVENUE_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
